export const TERMS_VERSION = "1.6";
export const PRIVACY_VERSION = "1.7";
export const LEGAL_EFFECTIVE_DATE = "September 17, 2026";
